import { ProductViewPlace, ProductViewPlaceValue } from '@shared/product/models';

export function isPlaceholderEnabledUseCase(place: ProductViewPlace): boolean {
    return place === ProductViewPlaceValue.PRODUCT_DETAIL;
}
